import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const excludedUrls = ['/ping', '/getcountunreadmessages'];
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError(
        (
          httpErrorResponse: HttpErrorResponse,
          _: Observable<HttpEvent<any>>
        ) => {
          const isExcluded = excludedUrls.some((url) =>
            request.url.endsWith(url)
          );
          if (httpErrorResponse.status == 401 && !isExcluded) {
            this._auth.logout();
            this.router.navigate(['/home'], { relativeTo: this.route });
          }
          return throwError(httpErrorResponse);
        }
      )
    );
  }
}
